import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Style/Checkbox.scss";
import "../../Style/__button.scss";
import "../../Style/InsertModal.scss";
import "../../Style/FiscalCashRegisterForm.scss";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import TextField from "@mui/material/TextField";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { AddElementsButton } from "../../Components/AddElementsButton";
import Autocomplete from "@mui/material/Autocomplete";
import { getCompanyUnits } from "../../GetData/CompanyUnitsData";
import ATKOnboardingWizard from "./ATKOnboardingWizard";
import { confirmATKSave } from "./confirmATKSave";

function InsertFiscalCashRegister(props) {
  const [hash, setHash] = useState("");
  const [companyID, setCompanyID] = useState();
  const [posID, setPosID] = useState();
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [unitID, setUnitID] = useState(0);
  const [atkBranchID, setAtkBranchID] = useState("");
  const [externalModuleCode, setExternalModuleCode] = useState("");
  const [maxSecondaryDevices, setMaxSecondaryDevices] = useState(0);
  const [atkPOSID, setAtkPOSID] = useState("");
  const [atkAppicationID, setAtkAppicationID] = useState("");
  const [atkFiscalizationNumber, setAtkFiscalizationNumber] = useState("");
  const [atkSEFCode, setAtkSEFCode] = useState("");
  const [atkPrivateKeyPemEncrypted, setAtkPrivateKeyPemEncrypted] = useState("");
  const [atkSignedCertificatePem, setAtkSignedCertificatePem] = useState("");

  const [company, setCompany] = useState([]);
  const [paymentsAccounts, setPaymentsAccounts] = useState([]);
  const [companyUnits, setCompanyUnits] = useState([]);
  const [externalModules, setExternalModules] = useState([]);

  // ATK Onboarding states
  const [createdFCRId, setCreatedFCRId] = useState(null);  // ID e rekordit të ri pas Phase 1
  const [isPartialSaved, setIsPartialSaved] = useState(false);  // Phase 1 e kryer
  const [savingPhase1, setSavingPhase1] = useState(false);
  const [savingATK, setSavingATK] = useState(false);
  const [isATKBusy, setIsATKBusy] = useState(false);

  const email = LoginUserDetailed(); // ndryshoni me emailin e përdoruesit të kyqur
  const headers = authHeader();

  /**
   * PHASE 1: Save Accountree data (Sections 1 + 4)
   * Insert with NULL ATK fields
   */
  const handleSavePhase1 = (event) => {
    event.preventDefault();
    if (savingPhase1 || isPartialSaved) return;
    
    // Validimi i grundimit
    if (!hash || !companyID || !posID) {
      errorAlert("Hash Code, Kompania dhe Arka janë të detyrueshme.");
      return;
    }

    const parsedMaxSecondaryDevices = Number(maxSecondaryDevices);
    if (
      maxSecondaryDevices === "" ||
      !Number.isInteger(parsedMaxSecondaryDevices) ||
      parsedMaxSecondaryDevices < 0
    ) {
      errorAlert(
        "Numri i pajisjeve Secondary duhet të jetë numër i plotë, zero ose më i madh.",
      );
      return;
    }

    const phase1Data = {
      CashRegisterHash: hash,
      POSID: posID,
      CompanyID: companyID,
      LocationName: location,
      Description: description,
      CreatedByUser: email,
      IsActive: isActive,
      UnitID: unitID,
      ExternalModuleCode: externalModuleCode || null,
      MaxSecondaryDevices: Number(maxSecondaryDevices ?? 0),
      // ATK fields = NULL for Phase 1
      ATKBranchID: null,
      ATKPOSID: 0,
      ATKAppicationID: 0,
      ATKFiscalizationNumber: null,
      ATKSEFCode: null,
      ATKPrivateKeyPemEncrypted: null,
      ATKSignedCertificatePem: null,
    };

    setSavingPhase1(true);
    axios
      .post(ApiLink.API_URL + "FiscalCashRegister", phase1Data, { headers })
      .then((response) => {
        const newId = Number(response.data?.Id);
        if (response.data?.success !== true || !Number.isInteger(newId) || newId <= 0) {
          throw new Error("Serveri nuk konfirmoi ID-në e regjistrit. Kontrollo listën para se të provosh përsëri.");
        }
        setCreatedFCRId(newId);
        setIsPartialSaved(true);
        handleSuccess("P.O.S-i u ruajt në Accountree. Vazhdo me ATK Onboarding.");
        props.refreshData();
      })
      .catch((error) => {
        console.error("FiscalCashRegister Phase 1 failed:", error?.response?.data || error);
        errorAlert("Ruajtja nuk u konfirmua. Kontrollo listën e P.O.S. para se të provosh përsëri, sepse regjistri mund të jetë krijuar.", error);
        props.refreshData();
      })
      .finally(() => setSavingPhase1(false));
  };

  /**
   * PHASE 2: Handle callback from ATK Onboarding Wizard
   * Update record with ATK values via PUT request
   */
  const handleATKOnboardingComplete = async (onboardingData) => {
    if (savingATK || !createdFCRId) return false;
    const parsedMaxSecondaryDevices = Number(maxSecondaryDevices);
    if (
      maxSecondaryDevices === "" ||
      !Number.isInteger(parsedMaxSecondaryDevices) ||
      parsedMaxSecondaryDevices < 0
    ) {
      errorAlert(
        "Numri i pajisjeve Secondary duhet të jetë numër i plotë, zero ose më i madh.",
      );
      return false;
    }

    // Përditëso local state për UI
    setAtkBranchID(onboardingData.atkBranchID);
    setAtkPOSID(onboardingData.atkPOSID);
    setAtkAppicationID(onboardingData.atkAppicationID);
    setAtkFiscalizationNumber(onboardingData.atkFiscalizationNumber);
    setAtkSEFCode(onboardingData.atkSEFCode);
    setAtkPrivateKeyPemEncrypted(onboardingData.atkPrivateKeyPemEncrypted);
    setAtkSignedCertificatePem(onboardingData.atkSignedCertificatePem);

    // Hapi i nxehtë: UPDATE në backend me vlerat ATK
    const updateData = {
      Id: createdFCRId,
      CashRegisterHash: hash,
      POSID: posID,
      CompanyID: companyID,
      LocationName: location,
      Description: description,
      ModifiedByUser: email,
      IsActive: isActive,
      UnitID: unitID,
      ExternalModuleCode: externalModuleCode || null,
      MaxSecondaryDevices: Number(maxSecondaryDevices ?? 0),
      ATKBranchID: onboardingData.atkBranchID ? Number(onboardingData.atkBranchID) : null,
      ATKPOSID: onboardingData.atkPOSID ? Number(onboardingData.atkPOSID) : 0,
      ATKAppicationID: onboardingData.atkAppicationID ? Number(onboardingData.atkAppicationID) : 0,
      ATKFiscalizationNumber: onboardingData.atkFiscalizationNumber || null,
      ATKSEFCode: onboardingData.atkSEFCode || null,
      ATKPrivateKeyPemEncrypted: onboardingData.atkPrivateKeyPemEncrypted || null,
      ATKSignedCertificatePem: onboardingData.atkSignedCertificatePem || null,
      ATKEnvironment: onboardingData.atkEnvironment || null,
    };

    setSavingATK(true);
    try {
      const response = await axios.put(ApiLink.API_URL + "FiscalCashRegister", updateData, { headers });
      if (response.data?.success !== true) {
        throw new Error(response.data?.message || "Serveri nuk e konfirmoi përditësimin.");
      }
      handleSuccess("P.O.S-i u përditësua me të dhënat ATK me sukses!");
      handleClose(true);
      return true;
    } catch (error) {
      console.error("FiscalCashRegister ATK update failed:", error?.response?.data || error);
      const saveStatus = await confirmATKSave(createdFCRId, onboardingData, headers);
      if (saveStatus === "saved") {
        handleSuccess("Konfigurimi ATK ishte ruajtur; përgjigjja nga serveri nuk kishte mbërritur.");
        handleClose(true);
        return true;
      }
      errorAlert(saveStatus === "unknown"
        ? "Nuk mund të verifikohet ruajtja. Kontrollo listën para se të provosh përsëri; të dhënat mbetën në formë."
        : "Përditësimi me ATK dështoi. Të dhënat mbetën në formë; provo përsëri.", error);
      return saveStatus === "unknown" ? "unknown" : false;
    } finally {
      setSavingATK(false);
    }
  };

  const handleATKCheckStatus = async (onboardingData) => {
    const status = await confirmATKSave(createdFCRId, onboardingData, headers);
    if (status === "saved") {
      handleSuccess("Konfigurimi ATK është ruajtur me sukses.");
      handleClose(true);
    }
    return status;
  };

  const handleClose = (afterSuccess = false) => {
    if (savingPhase1 || (isATKBusy && !afterSuccess) || (savingATK && !afterSuccess)) return;
    if (isPartialSaved && !afterSuccess && !window.confirm(
      "P.O.S. është ruajtur, por konfigurimi ATK nuk ka përfunduar. Nëse e mbyll tani, të dhënat e hapave ATK në këtë formë do të humbin. A dëshiron ta mbyllësh?",
    )) return;
    props.onHide();
    if (isPartialSaved) props.refreshData();
    setHash("");
    setPosID();
    setCompanyID();
    setLocation("");
    setDescription("");
    setIsActive(true);
    setUnitID(0);
    setAtkBranchID("");
    setExternalModuleCode("");
    setMaxSecondaryDevices(0);
    setAtkPOSID("");
    setAtkAppicationID("");
    setAtkFiscalizationNumber("");
    setAtkSEFCode("");
    setAtkPrivateKeyPemEncrypted("");
    setAtkSignedCertificatePem("");
    setCreatedFCRId(null);
    setIsPartialSaved(false);
    setIsATKBusy(false);
  };

  useEffect(() => {
    Promise.all([
      axios.get(ApiLink.API_URL + "companies", { headers }),
      axios.get(ApiLink.API_URL + "License/getSystemModule", { headers }),
    ])
      .then(([companyResponse, moduleResponse]) => {
        setCompany(companyResponse.data || []);
        const onlyExternalModules = (moduleResponse.data || []).filter(
          (item) => Number(item?.IsExternal) === 1 && Number(item?.IsActive) === 1,
        );
        setExternalModules(onlyExternalModules);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  // const fetchPaymentsAccount = async (id) => {
  //     try {
  //         const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedgerandCompany', { headers, params: { ledger: 101, id: id } });
  //         setPaymentsAccounts(response.data);
  //     } catch (error) {
  //         errorAlert("Gabim në kërkesë:", error);

  //         if (error.response && error.response.data && error.response.data.errorMessage) {
  //             errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
  //         } else if (error.message) {
  //             errorAlert(`Gabim: ${error.message}`);
  //         } else {
  //             errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //         }
  //     }
  // };

  const fetchPaymentsAccount = async (id) => {
    try {
      // Thirrja e parë (Accounts)
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedgerandCompany",
        {
          headers,
          params: { ledger: 101, id: id },
        },
      );
      setPaymentsAccounts(response.data);

      //marrja e njesive organizative
      const units = await getCompanyUnits(id);
      setCompanyUnits(units); 
    } catch (error) {
      // Logjika jote ekzistuese për error alert
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur.");
      }
    }
  };

  //Per ta zgjedhur kompanin
  const handleAutocompleteChangeCompany = (event, value) => {
    if (value) {
      setCompanyID(value.CompanyID);
      setPosID();
      fetchPaymentsAccount(value.CompanyID);
    } else {
      setCompanyID();
      setPosID();
      setAtkPOSID("");
    }
  };

  const defaultPropsCompany = {
    options: company,
    getOptionLabel: (option) => option.CompanyName || "",
  };

  const handleAutocompletePaymentOptions = (event, value) => {
    if (value) {
      setPosID(value.AccountID);
    } else {
      setPosID();
    }
  };

  const defaultPropsPaymentOptions = {
    options: paymentsAccounts,
    getOptionLabel: (option) => option.AccountName || "",
  };

  //Per ta zgjedhur njesin e kompanis
  const handleAutocompleteChangeCompanyUnit = (event, value) => {
    if (value) {
      setUnitID(value.UnitID);
    } else {
      setUnitID("");
    }
  };

  const defaultPropsCompanyUnit = {
    options: companyUnits,
    getOptionLabel: (option) => option.UnitName || "",
  };

  const defaultPropsExternalModule = {
    options: externalModules,
    getOptionLabel: (option) => option.ModuleName || "",
  };

  const handleAutocompleteExternalModule = (event, value) => {
    if (value) {
      setExternalModuleCode(value.ModuleCode || "");
    } else {
      setExternalModuleCode("");
    }
  };

  return (
    <Modal
      {...props}
      onHide={() => handleClose()}
      size="xl"
      dialogClassName="fcr-modal"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <form onSubmit={handleSavePhase1} className="fcr-form">
        <Modal.Header className="fcr-form__header">
          <div>
            <Modal.Title id="contained-modal-title-vcenter" className="fcr-form__title">
              {isPartialSaved ? "Konfigurimi ATK" : "Krijo P.O.S. të ri"}
            </Modal.Title>
            <p className="fcr-form__subtitle">
              {isPartialSaved 
                ? "Plotëso verifikimin me ATK." 
                : "Konfigurimi i arkës, kompanisë dhe të dhënave fiskale ATK."}
            </p>
          </div>
          <span className="fcr-form__badge">{isPartialSaved ? "Faza 2/2" : "Faza 1/2"}</span>
        </Modal.Header>
        <Modal.Body className="fcr-form__body">
          {!isPartialSaved && (
            <>
              <section className="fcr-form__section">
                <div className="fcr-form__section-header">
                  <span>1</span>
                  <div>
                    <h4>Identifikimi i P.O.S</h4>
                    <p>Zgjedh kompaninë, arkën dhe lokacionin operativ.</p>
                  </div>
                </div>
                <div className="fcr-form__grid fcr-form__grid--two">
                  <TextField
                    fullWidth
                    id="HashCode"
                label="Hash Code"
                variant="outlined"
                type="text"
                name="HashCode"
                autoComplete="off"
                required
                value={hash}
                onChange={(event) => setHash(event.target.value)}
              />
              <TextField
                fullWidth
                id="LocationName"
                label="Lokacioni P.O.S-it"
                variant="outlined"
                type="text"
                name="LocationName"
                autoComplete="off"
                value={location}
                onChange={(event) => setLocation(event.target.value)}
              />
              <Autocomplete
                fullWidth
                {...defaultPropsCompany}
                id="company-select"
                includeInputInList
                onChange={handleAutocompleteChangeCompany}
                renderInput={(params) => (
                  <TextField {...params} label="Zgjedh kompaninë" required />
                )}
              />
              <Autocomplete
                fullWidth
                {...defaultPropsPaymentOptions}
                id="cash-register-select"
                includeInputInList
                onChange={handleAutocompletePaymentOptions}
                renderInput={(params) => (
                  <TextField {...params} label="Zgjedh arkën" required />
                )}
              />
              <Autocomplete
                fullWidth
                {...defaultPropsCompanyUnit}
                id="company-unit-select"
                includeInputInList
                onChange={handleAutocompleteChangeCompanyUnit}
                renderInput={(params) => (
                  <TextField {...params} label="Njësia organizative" />
                )}
              />
              <Autocomplete
                fullWidth
                {...defaultPropsExternalModule}
                id="external-module-select"
                includeInputInList
                onChange={handleAutocompleteExternalModule}
                value={
                  externalModules.find(
                    (option) => (option.ModuleCode || "") === externalModuleCode,
                  ) || null
                }
                renderInput={(params) => (
                  <TextField {...params} label="Moduli i jashtëm" />
                )}
              />
              <TextField
                fullWidth
                required
                id="MaxSecondaryDevices"
                label="Numri maksimal i pajisjeve Secondary"
                variant="outlined"
                type="number"
                name="MaxSecondaryDevices"
                value={maxSecondaryDevices}
                onChange={(event) => setMaxSecondaryDevices(event.target.value)}
                onInvalid={(event) => {
                  event.preventDefault();
                  errorAlert(
                    "Numri i pajisjeve Secondary duhet të jetë numër i plotë, zero ose më i madh.",
                  );
                }}
                inputProps={{ min: 0, step: 1 }}
              />
            </div>
          </section>

          <section className="fcr-form__section">
            <div className="fcr-form__section-header">
              <span>4</span>
              <div>
                <h4>Statusi dhe përshkrimi</h4>
                <p>Kontrollo nëse P.O.S është aktiv dhe shto shënime të brendshme.</p>
              </div>
            </div>
            <div className="fcr-form__grid">
              <TextField
                fullWidth
                id="Description"
                label="Përshkrimi"
                variant="outlined"
                type="text"
                autoComplete="off"
                name="Description"
                multiline
                minRows={3}
                value={description}
                onChange={(event) => setDescription(event.target.value)}
              />
            </div>
          </section>
            </>
          )}

          {isPartialSaved && (
            <>
              {/* ATK Onboarding Button - only in Phase 2 */}
              <section className="fcr-form__section">
                <ATKOnboardingWizard
                  onComplete={handleATKOnboardingComplete}
                  onCheckStatus={handleATKCheckStatus}
                  branchId={atkBranchID}
                  initialATKPOSID={atkPOSID}
                  recordId={createdFCRId}
                  onBusyChange={setIsATKBusy}
                />
              </section>
            </>
          )}
        </Modal.Body>
        <div className="fcr-form__footer">
          {!isPartialSaved && (
            <>
              <label className="fcr-form__switch">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={(event) => setIsActive(event.target.checked)}
                />
                <span></span>
                P.O.S aktiv
              </label>
              <div className="fcr-form__actions">
                <button type="button" className="fcr-form__secondary-button" onClick={() => handleClose()} disabled={savingPhase1}>
                  Anulo
                </button>
                <button type="submit" className="fcr-form__primary-button" disabled={savingPhase1}>
                  {savingPhase1 ? "Duke ruajtur..." : "Vazhdo me ATK"}
                </button>
              </div>
            </>
          )}
          {isPartialSaved && (
            <>
              <div className="fcr-form__actions">
                <button type="button" className="fcr-form__secondary-button" onClick={() => handleClose()} disabled={savingATK || isATKBusy}>
                  Anulo
                </button>
              </div>
            </>
          )}
        </div>
      </form>
    </Modal>
  );
}

export default function InsertData(props) {
  const [modalShow, setModalShow] = React.useState(false);

  const handleRefreshData = () => {
    props.fetchData(); // Thirrja e funksionit per refresh te dhenave
  };
  return (
    <div>
      {props.type === "text" ? (
        <AddElementsButton
          text="Krijo P.O.S"
          onClick={() => setModalShow(true)}
          icon="bi bi-upc-scan"
          className="button-68"
        />
      ) : props.type === "insert" ? (
        <AddElementsButton
          text="Krijo P.O.S"
          onClick={() => setModalShow(true)}
          icon="bi bi-upc-scan"
          className="button-15"
        />
      ) : props.type === "menu" ? (
        <i class="bi bi-upc-scan" onClick={() => setModalShow(true)}></i>
      ) : (
        <AddBoxIcon
          style={{ height: "29px", color: "black" }}
          onClick={() => setModalShow(true)}
        />
      )}
      <InsertFiscalCashRegister
        show={modalShow}
        onHide={() => setModalShow(false)}
        refreshData={handleRefreshData}
      />
    </div>
  );
}
